import { writeFile, utils } from 'xlsx';

interface ExcelParserOptions {
  data: any[];
  headers: any[];
  tableId: string;
  newFileName?: string;
}

const getItemValue = (obj: any, path: string): any => {
  return path.split('.').reduce((acc, part) => acc && acc[part], obj);
};

export const excelParser = ({
  data,
  headers,
  tableId,
  newFileName = 'exported-data',
}: ExcelParserOptions) => {
  const columnOrderStr = localStorage.getItem(`${tableId}-column-order`);
  let columnOrder: any[] = [];

  if (columnOrderStr) {
    columnOrder = JSON.parse(columnOrderStr);
  } else {
    columnOrder = headers;
  }

  const rearrangeData = (data: any[], columnOrder: any[]) => {
    return data.map((row) => {
      const newRow: any = {};
      columnOrder.forEach((column) => {
        if (column.active && column.value !== 'actions') {
          newRow[column.text] = getItemValue(row, column.value);
        }
      });
      return newRow;
    });
  };

  const rearrangedData = rearrangeData(data, columnOrder);

  const worksheet = utils.json_to_sheet(rearrangedData);
  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, worksheet, 'Sheet1');

  try {
    writeFile(workbook, `${newFileName}.xlsx`);
  } catch (e) {
    throw new Error('Parsing failed!');
  }
};
